import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.TrancheService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class TrancheService extends RpcClass{

    /**
     *  @class TrancheService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/TrancheService.TrancheService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param tranche {module:src/server/com/silkplm/model/plm/Tranche.Tranche} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfOrderIsAlreadyIntegratedWithExternalSystem(tranche) {
            return RpcClass.rpcCall('/rpc/plm/services/tranche-service/check-if-order-is-already-integrated-with-external-system', [tranche]);
    }
    /** 
     * @async
     * @param order {module:src/server/com/silkplm/model/plm/Order.Order} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfTrancheIsIntegrated(order) {
            return RpcClass.rpcCall('/rpc/plm/services/tranche-service/check-if-tranche-is-integrated', [order]);
    }
    /** 
     * @async
     * @param tranche {module:src/server/com/silkplm/model/plm/Tranche.Tranche} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Booking.Booking>}
     */
     findBooking(tranche) {
            return RpcClass.rpcCall('/rpc/plm/services/tranche-service/find-booking', [tranche]);
    }
    /** 
     * @async
     * @param trancheId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails[]>}
     */
     findOrderDetailsForTranche(trancheId) {
            return RpcClass.rpcCall('/rpc/plm/services/tranche-service/find-order-details-for-tranche', [trancheId]);
    }
    /** 
     * @async
     * @param numberOfTranche {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Tranche.Tranche>}
     */
     findTrancheByNumberOfTranche(numberOfTranche) {
            return RpcClass.rpcCall('/rpc/plm/services/tranche-service/find-tranche-by-number-of-tranche', [numberOfTranche]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.TrancheService';
metadata.__type_short__ = 'TrancheService';
TrancheService.prototype.__metadata__ = metadata;

TrancheService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/TrancheService */
export default TrancheService

export { TrancheService }
